// extracted by mini-css-extract-plugin
module.exports = {"emailLink":"Blacklisted-Blacklisted-emailLink-e54c948e"};